<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Created Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtDateFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Source">
      <b-form-checkbox
        v-for="option in sourceOptions"
        :key="option.value"
        v-model="customerSourceFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Show">
      <b-form-checkbox
        v-for="option in customerOptions"
        :key="option.value"
        v-model="customerTypeFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex justify-content-between gap-3 mt-2">
      <b-button
        variant="outline-primary"
        class="mr-1 w-50"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        class="w-50"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // vSelect,
    flatPickr,
  },
  props: {
    createdAtDateFilter: {
      type: [String, null],
      default: null,
    },
    customerSourceFilter: {
      type: [Array, null],
      default: () => [],
    },
    customerTypeFilter: {
      type: [Array, null],
      default: () => [],
    },
    customerOptions: {
      type: Array,
      default: () => [],
    },
    sourceOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      createdAtDateFilterValue: this.createdAtDateFilter,
      customerTypeFilterValue: JSON.parse(JSON.stringify(this.customerTypeFilter)) || [],
      customerSourceFilterValue: JSON.parse(JSON.stringify(this.customerSourceFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    createdAtDateFilter: {
      immediate: true,
      handler(val) {
        this.createdAtDateFilterValue = val
      },
    },
    customerTypeFilter: {
      immediate: true,
      handler(val) {
        this.customerTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    customerSourceFilter: {
      immediate: true,
      handler(val) {
        this.customerSourceFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.createdAtDateFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:createdAtDateFilter', this.createdAtDateFilterValue)
      this.$emit('update:customerTypeFilter', this.customerTypeFilterValue)
      this.$emit('update:customerSourceFilter', this.customerSourceFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtDateFilterValue = ''
      this.customerTypeFilterValue = []
      this.customerSourceFilterValue = []
      this.$emit('update:createdAtDateFilter', this.createdAtDateFilterValue)
      this.$emit('update:customerTypeFilter', this.customerTypeFilterValue)
      this.$emit('update:customerSourceFilter', this.customerSourceFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
